import { useState } from 'react'
import { Modal, type ModalProps } from '../modal'

interface CancelRequestModalProps
  extends Omit<
    ModalProps,
    'isOpen' | 'setOpen' | 'title' | 'submitButtonLabel' | 'backButtonLabel'
  > {
  content?: string
  cancelAction: () => void
}

export const CancelRequestModal = (props: CancelRequestModalProps) => {
  const [isOpen, setOpen] = useState(false)
  return (
    <Modal
      {...props}
      isOpen={isOpen}
      setOpen={setOpen}
      title="Cancelar Nova Análise"
      backButtonLabel="Voltar"
      backButtonLabelClassName="font-bold text-md"
      submitButtonLabel="Cancelar"
      submitAction={props.cancelAction}
      submitButtonclassName="font-bold text-md bg-[var(--brand-red)]"
      trigger={{
        label: 'Cancelar',
        className:
          'bg-white text-[var(--brand-blue-2)] shadow-none text-base font-bold underline underline-offset-4 border-none'
      }}
    >
      {props.content ?? (
        <div className="flex gap-4 flex-col">
          <h1>
            Confirmando está ação você estará descartando a nova análise que
            estava realizando.
          </h1>
          <h1>Todos os dados inseridos até o momento serão perdidos.</h1>
          <strong>Deseja seguir com o cancelamento?</strong>
        </div>
      )}
    </Modal>
  )
}
